import { createContext, useContext } from 'react'
import { type MyAccountDialogProviderProps } from './MyAccountDialogProvider'

interface MyAccountDialogContextProps {
  dialogPayload?: MyAccountDialogProviderProps
  openDialog: () => void
  closeDialog: () => void
  showDialog: (props: MyAccountDialogProviderProps) => void
  showDialogServerError: () => void
}

export const MyAccountDialogContext = createContext<MyAccountDialogContextProps | undefined>(undefined)

export const useContextMyAccountDialog = () => {
  const context = useContext(MyAccountDialogContext)
  if (!context) {
    throw new Error('useContextMyAccountDialog must be used within an MyAccountDialogProvider')
  }
  return context
}
